export default "__VITE_PUBLIC_ASSET__6bfd78c1__"